import { Component } from '@angular/core';

/** Component that displays a processing bar animation. */
@Component({
	selector: 'crownx-processing-bar',
	standalone: true,
	templateUrl: './processing-bar.component.html',
	styleUrls: ['./processing-bar.component.scss']
})
export class ProcessingBarComponent {

}